export enum EStorageKeys {
  ADD_SUPPLIER = 'appSupplier',
  ANALYTICS_TABS = 'analyticsTabs',
  AUTH_TOKEN = 'authenticationToken',
  AUTH_TOKEN_EXPIRE = 'authTokenExpire',
  BOOK_DRAFT = 'bookDraftData',
  BOOK_FORM = 'bookFormSession',
  CHECKLIST_FORM_SESSION = 'checklistFormSession',
  CLIENT_ID = 'clientId',
  CUSTOM_PAYMENT_TOKEN = 'customPaymentTokenKey',
  DRAFT_CHECKLIST = 'draftChecklistData',
  ENTITY_TYPE = 'entityType',
  FOOD_CERTIFICATION_TYPE = 'foodCertificationType',
  GGAP_CERTIFICATION_TYPE = 'ggapCertificationType',
  IS_BOOKING_FROM_PREVIOUS = 'isBookingFromPrevious',
  LT_LOCATION_SELECTED = 'ltLocationSelected',
  MFA_REQUEST_ID = 'mfaRequestId',
  MFA_REQUEST_TIME = 'mfaRequestTime',
  MISSING_IMPORTANT_DOCUMENT_IDS = 'missingImportantDocumentIds',
  OPEN_ID = 'openId',
  ORDER_DETAIL_BACK = 'orderDetailBack',
  PAY_PREFILLED_CLICK_PAY_BUTTON_SENT = 'payPrefilledClickPayButtonSent',
  PERFORMANCE_TIMINGS = 'performanceTimings',
  PRODUCT_CATEGORIES = 'productCategories',
  PRODUCT_TREE = 'productTree',
  PRODUCT_TYPE_WITH_CHECKLIST = 'productTypesWithChecklist',
  PSI_REPORT_DETAIL = 'psiReportDetail',
  REFLOW_MATERIALS = 'reflowMaterials',
  REFORM_FLOW = 'reflowFormSession',
  REFRESH_TOKEN = 'refreshToken',
  REFRESH_TOKEN_EXPIRE = 'refreshTokenExpire',
  REPORT_DETAIL_SESSION = 'reportDetailSession',
  SELECTED_LEGAL_ENTITY = 'selectedLegalEntity',
  SEND_MOBILE_APP_LINK = 'showMobileBannerCookie',
  SESSION_ID = 'sessionId',
  SHOW_REPORT_DETAIL_SESSION = 'showReportDetailSession',
  TARGET_BOOK_PREVIOUS = 'targetBookPrevious',
  TARGET_BOOK_ROUTE = 'targetBookRoute',
  USER_DATA = 'userData',
  USER_ID = 'userId',
  USER_PERMISSIONS = 'userPermissions',
  WQS_CONTACT_TYPE = 'wqsContactType',
}
